import * as graphql from 'generated/graphql';
import styled from 'styled-components';
import { useState } from 'react';
import {
	ActionIcon,
	Box,
	Button,
	Divider,
	Flex,
	Group,
	Popover,
	ScrollArea,
	Text,
	Title,
	UnstyledButton,
} from '@mantine/core';
import PlusIcon from 'packages/kakapo-ui-kit/assets/icons/PlusIcon';

import NewCommentEditor from './CommentEditor';

import Comment from './Comment';

import { CloseIcon, ConversationIcon } from '@treams/treams-icons';
import CommentIcon from 'packages/kakapo-ui-kit/assets/icons/CommentIcon';
import { useDisclosure } from '@mantine/hooks';

const ConversationPlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 8px;
	padding: 16px;
	height: 100px;

	svg {
		max-width: 100px;
		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}
`;

export default function Comments({ item }: { item: graphql.ConversationItemWithComments }) {
	const [showCommentEditor, setShowCommentEditor] = useState(item.comments.length === 0);
	const [opened, { close, open }] = useDisclosure(false);

	const handleClose = () => {
		if (item.comments.length > 0) {
			setShowCommentEditor(false);
		}

		close();
	};

	return (
		<Popover
			width={300}
			position="bottom"
			withArrow
			shadow="md"
			opened={opened}
			onClose={handleClose}
		>
			<Popover.Target>
				<UnstyledButton onClick={open}>
					<Group gap="8px">
						{item.comments.length} <CommentIcon />
					</Group>
				</UnstyledButton>
			</Popover.Target>
			<Popover.Dropdown p={0}>
				<Group justify="space-between">
					<Title order={5} p="xs">
						{/* @TODO: Translate */}
						Notities
					</Title>
					<ActionIcon size="sm" variant="transparent" m="xs" onClick={handleClose}>
						<CloseIcon />
					</ActionIcon>
				</Group>
				<Divider />
				{showCommentEditor ? (
					<>
						{item.comments.length === 0 && (
							<ConversationPlaceholder>
								<ConversationIcon />

								<Text size="sm" c="dimmed">
									{/* @TODO: Translate */}
									Geen notities toegevoegd.
								</Text>
							</ConversationPlaceholder>
						)}
						<Box p="xs">
							<NewCommentEditor
								item={item}
								onNewComment={() => {
									setShowCommentEditor(false);
								}}
								onDiscard={() => {
									setShowCommentEditor(false);
								}}
							/>
						</Box>
					</>
				) : (
					<>
						<ScrollArea.Autosize mah="300px" scrollbars="y" type="auto">
							{item.comments.map((comment) => (
								<Comment comment={comment} key={comment.id} />
							))}
						</ScrollArea.Autosize>
						<Divider />

						<Flex align="flex-end" direction="column" pt="4px" pb="4px">
							<Button
								onClick={() => setShowCommentEditor(true)}
								size="xs"
								variant="transparent"
								color="#4840BE"
								leftSection={<PlusIcon color="#4840BE" />}
							>
								{/* @TODO: Translate */}
								Notitie toevoegen
							</Button>
						</Flex>
					</>
				)}
			</Popover.Dropdown>
		</Popover>
	);
}
